import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import './utils/i18n';
import { MaterialThemeProvider } from './provider/MaterialThemeProvider';
import App from './app/App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './shared/hooks/ScrollToTop';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { setupInterceptors } from './utils';
import TagManager from 'react-gtm-module';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './ErrorBoundary';

setupInterceptors();

TagManager.initialize({
    gtmId: process.env.VITE_TAG_MANAGER_ID ?? '',
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    // <React.StrictMode>
    <BrowserRouter>
        <MaterialThemeProvider>
            <Provider store={store}>
                <HelmetProvider>
                    <ScrollToTop>
                        <ErrorBoundary>
                            <App />
                        </ErrorBoundary>
                    </ScrollToTop>
                </HelmetProvider>
            </Provider>
        </MaterialThemeProvider>
    </BrowserRouter>
    // </React.StrictMode>
);

reportWebVitals();
